module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticeHandsHips-b4f26c1a9e0dd97ed5eb777b8471d8dc.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticeHandsHips.png
// module id = 2432
// module chunks = 2